import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (password: string) => void;
    passwordError?: string;
    extendedStyles?: ConfirmEmailChangeModalStyles;
}

export interface ConfirmEmailChangeModalStyles {
    modal?: ModalPresentationProps;
    descriptionText?: TypographyPresentationProps;
    passwordTextField?: TextFieldPresentationProps;
    buttonWrapper?: InjectableCss;
    confirmButton?: ButtonPresentationProps;
}

export const confirmEmailChangeModalStyles: ConfirmEmailChangeModalStyles = {
    descriptionText: {
        css: css`
            margin-bottom: 15px;
            display: block;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            margin-top: 15px;
        `,
    },
};

const ConfirmEmailChangeModal = ({ isOpen, onClose, onConfirm, passwordError, extendedStyles }: OwnProps) => {
    const [styles] = useState(() => mergeToNew(confirmEmailChangeModalStyles, extendedStyles));
    const [currentPassword, setCurrentPassword] = useState("");

    const handleClose = () => {
        setCurrentPassword("");
        onClose();
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (currentPassword) {
            onConfirm(currentPassword);
        }
    };

    return (
        <Modal
            headline={translate("Confirm Email Change")}
            {...styles.modal}
            isOpen={isOpen}
            handleClose={handleClose}
            size={400}
        >
            <form onSubmit={handleSubmit}>
                <Typography {...styles.descriptionText}>
                    {siteMessage("Account_ConfirmEmailChange_Description")}
                </Typography>
                <TextField
                    {...styles.passwordTextField}
                    type="password"
                    label={translate("Current Password")}
                    value={currentPassword}
                    onChange={e => setCurrentPassword(e.currentTarget.value)}
                    error={passwordError}
                    data-test-selector="confirmEmailChange_currentPassword"
                    autoComplete="current-password"
                />
                <StyledWrapper {...styles.buttonWrapper}>
                    <Button
                        {...styles.confirmButton}
                        type="submit"
                        disabled={!currentPassword}
                        data-test-selector="confirmEmailChange_submit"
                    >
                        {translate("Confirm")}
                    </Button>
                </StyledWrapper>
            </form>
        </Modal>
    );
};

export default ConfirmEmailChangeModal;
